import { errorHandler } from 'pobble-components/dist/error-handler'
import { useMe } from 'pobble-components/dist/pobble-user'
import { useState } from 'react'
import { apiRequestTeacherAccess } from '../../../../../common/api/profile'

export const useRegisterTeacher = () => {
  const [pending, setPending] = useState(false)
  const { refetchMe } = useMe()
  const registerTeacher = schoolFromStore => {
    const payload = schoolFromStore.id
      ? { school_id: schoolFromStore.id }
      : {
          title: schoolFromStore.name,
          phone: schoolFromStore.phone,
          email: schoolFromStore.email,
          website: schoolFromStore.website,
          address: schoolFromStore.address
        }
    setPending(true)
    apiRequestTeacherAccess(payload)
      .then(refetchMe)
      .catch(errorHandler)
  }
  return {
    registerTeacher,
    pending
  }
}
